import React from "react";
import { Button } from "../button/button";
import { ButtonWithTooltip } from "../button-with-tooltip/button-with-tooltip";
import "./footer.scss";

interface FooterProps {
  cancelButtonText: string;
  submitButtonText: React.ReactNode;
  onCancelClick: () => void;
  onSubmitClick: () => void;
  isDisabled?: boolean;
  isCancelDisabled?: boolean;
  children?: React.ReactNode;
  /** Render the original native buttons. @default true */
  useNative?: boolean;
  /** Enable the Submit tooltip when useNative is false. @default false */
  showTooltip?: boolean;
  /** Submit tooltip content, used when useNative is false. */
  tooltipContent?: React.ReactNode;
}

export function Footer(props: FooterProps) {
  const { useNative = true, showTooltip = false } = props;
  return (
    <div className="footer">
      {props.children && props.children}
      {useNative ? (
        <>
          <button
            className="footer-button-cancel"
            onClick={props.onCancelClick}
            disabled={props.isCancelDisabled}
          >
            {props.cancelButtonText}
          </button>
          <button
            className="footer-button-submit"
            onClick={props.onSubmitClick}
            disabled={props.isDisabled}
          >
            {props.submitButtonText}
          </button>
        </>
      ) : (
        <>
          <Button
            buttonType="secondary"
            size="medium"
            className="footer-button-cancel"
            onClick={props.onCancelClick}
            disabled={props.isCancelDisabled ?? false}
          >
            {props.cancelButtonText}
          </Button>
          <ButtonWithTooltip
            buttonType="primary"
            size="medium"
            className="footer-button-submit"
            onClick={props.onSubmitClick}
            disabled={props.isDisabled ?? false}
            showTooltip={showTooltip}
            tooltipContent={props.tooltipContent}
          >
            {props.submitButtonText}
          </ButtonWithTooltip>
        </>
      )}
    </div>
  );
}
